import {conditions} from './index';
import {ConditionException} from '../../modules/error';

function _munge() {//데이터 갱신시
  let conditionFunc = function (dimensions, measures) {
    const field = this.__execs__.field;
    if (dimensions.length === 1 && measures.length === 2) {
      field.x = dimensions[0];
      field.yBar = measures[0];
      field.yLine = measures[1];
      field.region = this.mixedDimension();
      return conditions[0];
    } else throw new ConditionException();
  };
  this.condition(conditionFunc); // condiion 설정
  this.__execs__.munged = this.data();
}

export default _munge;


// WEBPACK FOOTER //
// ./layouts/combo/_munge.js